module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"inventories":"Inventuren","add":"Neu","sync":"Synchronisieren"},"en":{"inventories":"Inventories","add":"Add","sync":"Sync"}}')
  delete Component.options._Ctor
}
